import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger);


// Scroll to target
$('.scroll-to').on('click', function (event) {
	event.preventDefault();
	var target = $(this).attr('href');
	var $target = target ? $(target) : $();
	if (!$target.length) {
		return;
	}
	var $stickyNav = $('#sticky-nav');
	var $header = $('.page-head');
	var offset = $stickyNav.length
		? ($stickyNav.outerHeight() || 0)
		: ($header.outerHeight() || 0);
	$('html, body').stop().animate({
		scrollTop: $target.offset().top - offset
	}, 1000);
});

// ScrollTrigger.refresh();

// Scrolling Text
$(document).ready(function () {
	const scrollingStatSections = document.querySelectorAll('.scrolling-stat');

	scrollingStatSections.forEach((scrollingStatSection) => {
		let scrollingStatIcon = scrollingStatSection.querySelector('.scrolling-stat__icon');
		let scrollingStatImage = scrollingStatSection.querySelector('.scrolling-stat__image');
		let mediaMatch = gsap.matchMedia();

		if (scrollingStatSection.classList.contains('scrolling-stat--right')) {
			mediaMatch.add("(min-width: 1100px)", () => {
				let scrollingStat = gsap.timeline({
					scrollTrigger: {
						trigger: scrollingStatSection,
						start: 'top bottom',
						end: 'top center',
						scrub: 1,
						invalidateOnRefresh: true,
						//markers: true,
					},
				});
				scrollingStat.fromTo(
					scrollingStatIcon,
					{
						x: '100%',
					},
					{
						x: '0%',
					}
				);
				scrollingStat.fromTo(
					scrollingStatImage,
					{
						x: '200%',
					},
					{
						x: '0%',
					}
				);
			});

			mediaMatch.add("(max-width: 1099px)", () => {
				let scrollingStat = gsap.timeline({
					scrollTrigger: {
						trigger: scrollingStatSection,
						start: 'top bottom',
						end: 'top center',
						scrub: 1,
						invalidateOnRefresh: true,
						//markers: true,
					},
				});
				scrollingStat.fromTo(
					scrollingStatIcon,
					{
						x: '100%',
					},
					{
						x: '0%',
					}
				);
				scrollingStat.fromTo(
					scrollingStatImage,
					{
						x: '200%',
					},
					{
						x: '0%',
					}
				);
			});
		} else {
			mediaMatch.add("(min-width: 1100px)", () => {
				let scrollingStat = gsap.timeline({
					scrollTrigger: {
						trigger: scrollingStatSection,
						start: 'top bottom',
						end: 'top center',
						scrub: 1,
						invalidateOnRefresh: true,
						//markers: true,
					},
				});
				scrollingStat.fromTo(
					scrollingStatIcon,
					{
						x: '-100%',
					},
					{
						x: '0%',
					}
				);
				scrollingStat.fromTo(
					scrollingStatImage,
					{
						x: '-200%',
					},
					{
						x: '0%',
					}
				);
			});

			mediaMatch.add("(max-width: 1099px)", () => {
				let scrollingStat = gsap.timeline({
					scrollTrigger: {
						trigger: scrollingStatSection,
						start: 'top bottom',
						end: 'top center',
						scrub: 1,
						invalidateOnRefresh: true,
						//markers: true,
					},
				});
				scrollingStat.fromTo(
					scrollingStatIcon,
					{
						x: '-100%',
					},
					{
						x: '0%',
					}
				);
				scrollingStat.fromTo(
					scrollingStatImage,
					{
						x: '-200%',
					},
					{
						x: '0%',
					}
				);
			});
		}

	});
});